import React from "react";
import { Button, Card, CardBody, Input, Table } from "reactstrap";
import { teamService } from "services/team.service";



class CalendlyMap extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            calendlyMap: [],
            editingId: null,
            editData: {},
            newRow: {
                CalendlyReference: '',
                Email: '',
                PipedriveID: ''
            }
        }
    }

    componentDidMount() {
        teamService.getCalendlyMap().then(response => response.json()).then(data => this.setState({ calendlyMap: data }));
    }

    handleEdit = (id, rowData) => {
        this.setState({
            editingId: id,
            editData: { ...rowData }
        });
    }

    handleCancel = () => {
        this.setState({
            editingId: null,
            editData: {}
        });
    }

    handleInputChange = (field, value) => {
        this.setState({
            editData: {
                ...this.state.editData,
                [field]: value
            }
        });
    }

    handleNewRowChange = (field, value) => {
        this.setState({
            newRow: {
                ...this.state.newRow,
                [field]: value
            }
        });
    }

    handleSave = () => {
        teamService.saveCalendlyMap(this.state.editData)
            .then(() => {
                // Refresh the data
                return teamService.getCalendlyMap().then(response => response.json());
            })
            .then(data => {
                this.setState({
                    calendlyMap: data,
                    editingId: null,
                    editData: {}
                });
            })
            .catch(error => {
                console.error('Error saving calendly map:', error);
                // You could add error handling UI here
            });
    }

    handleAdd = () => {
        // Check if all fields are filled
        if (!this.state.newRow.CalendlyReference || !this.state.newRow.Email || !this.state.newRow.PipedriveID) {
            alert('Please fill in all fields');
            return;
        }

        teamService.saveCalendlyMap(this.state.newRow)
            .then(() => {
                // Refresh the data
                return teamService.getCalendlyMap().then(response => response.json());
            })
            .then(data => {
                this.setState({
                    calendlyMap: data,
                    newRow: {
                        CalendlyReference: '',
                        Email: '',
                        PipedriveID: ''
                    }
                });
            })
            .catch(error => {
                console.error('Error adding calendly map:', error);
                // You could add error handling UI here
            });
    }

    render() {
        console.log(this.state.calendlyMap);
        return (
            <div className="content">
                <h1>Calendly Map</h1>
                <Card>
                    <CardBody>
                        <Table>
                            <thead>
                                <tr>
                                    <th>Calendly User</th>
                                    <th>Email Address (in PD)</th>
                                    <th>Pipedrive User ID</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.calendlyMap.map(cm => {
                                    const isEditing = this.state.editingId === cm.ID;
                                    return (
                                        <tr key={cm.ID}>
                                            <td>
                                                {isEditing ? (
                                                    <Input
                                                        value={this.state.editData.CalendlyReference || ''}
                                                        onChange={(e) => this.handleInputChange('CalendlyReference', e.target.value)}
                                                    />
                                                ) : (
                                                    cm.CalendlyReference
                                                )}
                                            </td>
                                            <td>
                                                {isEditing ? (
                                                    <Input
                                                        value={this.state.editData.Email || ''}
                                                        onChange={(e) => this.handleInputChange('Email', e.target.value)}
                                                    />
                                                ) : (
                                                    cm.Email
                                                )}
                                            </td>
                                            <td>
                                                {isEditing ? (
                                                    <Input
                                                        value={this.state.editData.PipedriveID || ''}
                                                        onChange={(e) => this.handleInputChange('PipedriveID', e.target.value)}
                                                    />
                                                ) : (
                                                    cm.PipedriveID
                                                )}
                                            </td>
                                            <td>
                                                {isEditing ? (
                                                    <>
                                                        <Button color="success" size="sm" className="mr-2" onClick={this.handleSave}>
                                                            Save
                                                        </Button>
                                                        <Button color="secondary" size="sm" onClick={this.handleCancel}>
                                                            Cancel
                                                        </Button>
                                                    </>
                                                ) : (
                                                    <Button
                                                        color="primary"
                                                        size="sm"
                                                        onClick={() => this.handleEdit(cm.ID, cm)}
                                                    >
                                                        Edit
                                                    </Button>
                                                )}
                                            </td>
                                        </tr>
                                    )
                                })}
                                {/* Blank editable row at the bottom */}
                                <tr>
                                    <td>
                                        <Input
                                            placeholder="Enter Calendly User"
                                            value={this.state.newRow.CalendlyReference}
                                            onChange={(e) => this.handleNewRowChange('CalendlyReference', e.target.value)}
                                        />
                                    </td>
                                    <td>
                                        <Input
                                            placeholder="Enter Email Address"
                                            value={this.state.newRow.Email}
                                            onChange={(e) => this.handleNewRowChange('Email', e.target.value)}
                                        />
                                    </td>
                                    <td>
                                        <Input
                                            placeholder="Enter Pipedrive User ID"
                                            value={this.state.newRow.PipedriveID}
                                            onChange={(e) => this.handleNewRowChange('PipedriveID', e.target.value)}
                                        />
                                    </td>
                                    <td>
                                        <Button color="success" size="sm" onClick={this.handleAdd}>
                                            Add
                                        </Button>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </CardBody>
                </Card>
            </div>
        )
    }
}

export default CalendlyMap;